export default function NopaNote() {
  return (
    <a
      href="https://normipaiva.info/"
      className="
      flex flex-col  items-center 
      w-full
      p-4
      bg-day-darker/80 dark:bg-night-light/90
      text-sm
      font-sans
      text-gray-700      
    "
    >
      <div className="text-white text-center afont-bold ">
        Tsekkaa myös{" "}
        <span className="font-bold text-[#3ef] hover:underline">
          www.normipaiva.info
        </span>
        <span className="inline-block text-base mx-1">—</span>
        <span className=" leading-tight block sm:inline-block whitespace-nowrap">
          normaalein sää vuoden jokaiselle päivälle!
        </span>
      </div>
    </a>
  );
}
